<template>
  <UPageCard
    to="https://maomu.com/?from=nuxt.com.cn"
    target="_blank"
    :ui="{
      container: 'p-2 sm:p-2 gap-y-2',
      header: 'mb-0'
    }"
    class="group"
  >
    <template #header>
      <img  style="width: 171px;height: 100%" src="https://nuxt.com.cn/assets/ads/maomu-ads.png" alt="猫目社区" class="object-cover w-full rounded-(--ui-radius)" />
    </template>

    <p class="text-sm text-center text-(--ui-text-muted) group-hover:text-(--ui-text) transition text-pretty">
      一站式AI分享平台
    </p>
  </UPageCard>
</template>
